import { useTranslation } from 'react-i18next';
import { RESERVATION_FILTER_KEYS, type ReservationFilterKey } from './reservationList';

interface Props {
  counts: Record<ReservationFilterKey, number>;
  active: ReservationFilterKey;
  onSelect: (key: ReservationFilterKey) => void;
}

const LABEL_KEY: Record<ReservationFilterKey, string> = {
  all: 'waiter.notes.reservations.filterAll',
  upcoming: 'waiter.notes.reservations.filterUpcoming',
  arrived: 'waiter.notes.reservations.filterArrived',
  noShow: 'waiter.notes.reservations.filterNoShow',
  cancelled: 'waiter.notes.reservations.filterCancelled',
};

/**
 * SC-970 — the « Résas » tab's filter row: `Toutes n` · `À venir n` ·
 * `Arrivées n` · `Pas venues n` · `Annulées n`, default `À venir` (the screen
 * SC-966 shipped). Same chip shape as `EmporterSourceFilter`; every tap is a
 * plain selection, `all` already meaning "show everything".
 */
export default function ReservationsFilter({ counts, active, onSelect }: Props) {
  const { t } = useTranslation();

  return (
    <div
      data-testid="reservations-filter"
      role="group"
      aria-label={t('waiter.notes.tabs.reservations')}
      className="flex items-center gap-2 overflow-x-auto px-3 py-2 bg-paper border-b border-hairline"
    >
      {RESERVATION_FILTER_KEYS.map((key) => (
        <button
          key={key}
          type="button"
          data-testid={`reservations-chip-${key}`}
          aria-pressed={active === key}
          onClick={() => onSelect(key)}
          className={`shrink-0 h-11 px-2.5 flex items-center gap-1.5 rounded-full border-2 font-sans text-sm font-semibold ${
            active === key ? 'border-ink bg-ink text-paper' : 'border-transparent text-ink'
          }`}
        >
          {t(LABEL_KEY[key])} {counts[key]}
        </button>
      ))}
    </div>
  );
}
